export enum ProviderTypeAbbreviation {
  AN = 'AN',
  MI = 'MI',
  PT = 'PT',
  PC = 'PC',
  TC = 'TC',
}

export const ProviderTypeLabels: Record<ProviderTypeAbbreviation, string> = {
  [ProviderTypeAbbreviation.AN]: 'Anesthesia',
  [ProviderTypeAbbreviation.MI]: 'Miscellaneous',
  [ProviderTypeAbbreviation.PT]: 'Physical Therapy',
  [ProviderTypeAbbreviation.PC]: 'Professional Component',
  [ProviderTypeAbbreviation.TC]: 'Technical Component',
}
